import Fuse from 'fuse.js';
import uniqBy from 'lodash.uniqby';
import { selectors } from '../../store/conversations';
import { currentUserId } from '../../../core/selectors/user';
import { stringIsContained } from '../../utils/search';

const { conversations, sortedConversations } = selectors;

/*
 * WARNING: NOT ACTUALLY A REDUX ACTION
 */

const SEARCH_OPTIONS = {
  id: 'id',
  threshold: 0.1,
  location: 0,
  distance: 100,
  maxPatternLength: 60,
  minMatchCharLength: 1,
  keys: ['title'],
};

const filterConversations = (filterValue) => (_, getState) => {
  const state = getState();
  const haystack = sortedConversations(
    conversations(state),
    currentUserId(state)
  );

  const fuse = new Fuse(haystack, SEARCH_OPTIONS);

  return uniqBy([
    ...haystack.reduce(
      (matches, { title, id }) =>
        stringIsContained({ parent: title, child: filterValue })
          ? [...matches, id]
          : matches,
      []
    ),
    ...fuse.search(filterValue),
  ]);
};

export default filterConversations;
